// Walon (Walloon) – eigenständige Übersetzung
const wa = {
  common: {
    loading: "A tcherdj\u00EE...",
    back: "Riv\u00E9ni",
    next: "Shuvant",
    save: "Sov\u00E9",
    cancel: "Disprind\u00EE",
    close: "Serer",
    send: "\u00C9voy\u00EE",
    submit: "Rind\u00EE",
    yes: "Oy\u00EE",
    no: "N\u00E9n\u00EE",
    error: "Aroke",
    success: "R\u00E9uss\u00EE",
    search: "Cweri",
    more: "P\u00FBs",
    less: "M\u00E9s",
    optional: "opcionel",
    required: "Oblidj\u00EE",
    perMonth: "/ m\u00E5s",
    oneTime: "on fey",
    free: "Po r\u00E9n",
    skip: "Passer",
    pleaseWait: "Ratindez...",
    backToHome: "Riv\u00E9ni al p\u00E5dje principale",
    learnMore: "Sav\u00E9 pus",
    email: "Emaye",
    phone: "T\u00E9l\u00E9fone",
    password: "Mot d' passe",
    name: "No",
    selected: "tch\u00FBz\u00EE",
    available: "disponibe",
    used: "eployi",
    of: "di",
    question: "Cw\u00E9stion",
    craftBusiness: "Entreprise d' m\u00E9st\u00EE",
    forCraftBusinesses: "Po les entreprises d' m\u00E9st\u00EE",
    projectInquiry: "Dimande di prodjt",
    projectInquiries: "Dimandes di prodj\u00E9ts",
  },
  header: {
    dashboard: "Tablo d' b\u00F4rd",
    signOut: "Si d\u00E9conect\u00E9",
    completeProfile: "Fini l' profil",
    submitInquiry: "F\u00E9 one dimande di prodjt",
    signIn: "Si conect\u00E9",
    menuOpen: "Drovi l' menu",
    menuClose: "Serer l' menu",
    registerAsCraft: "S' \u00E9nscr\u00EEre come entreprise",
  },
  footer: {
    tagline: "Des dimandes di prodj\u00E9ts qualifiy\u00E9s.\nPo des entreprises d' m\u00E9st\u00EE s\u00E9l\u00E9cion\u00E9yes.",
    motto: "Trouv\u00E9 \u00B7 Rali\u00EE \u00B7 B\u00E2ti",
    platform: "Plate-forme",
    findCraft: "Trouv\u00E9 on m\u00E9st\u00EE",
    submitInquiry: "F\u00E9 one dimande",
    forCraftBusinesses: "Po les entreprises d' m\u00E9st\u00EE",
    aboutUs: "A propo d' nos",
    legalAndContact: "L\u00E9gal & Contact",
    imprint: "M\u00E9ncions l\u00E9gales",
    privacy: "Priv\u00E9c\u00EE",
    accessibility: "Accessi\u00EE",
    contact: "Contact",
    copyright: "\u00A9 {{year}} CRAFTFINDUS. Po les entreprises d' m\u00E9st\u00EE \u00E9n Almagne, Otriche et Swisse.",
  },
  cookies: {
    title: "Nos eploym\u00E8s des cookies",
    description: "Nos eploym\u00E8s des cookies po v' don\u00E9 l' miy\u00E8 exp\u00E9rience possibe. Pus d' infos dins nosse",
    privacyLink: "Politike di priv\u00E9c\u00EE",
    acceptAll: "Accept\u00E9 tot",
    configure: "Configur\u00E9",
    saveSelection: "Sov\u00E9 l' s\u00E9l\u00E9cion",
    onlyNecessary: "Rin k' les n\u00E9c\u00E9ssaires",
    necessary: "N\u00E9c\u00E9ssaire",
    necessaryDesc: "R\u00E9cwis po l' fonccionem\u00E8nt do site.",
    analytics: "Analise",
    analyticsDesc: "Nos \u00E5de \u00E0 comprindr com\u00E8nt l' site est eployi.",
    marketing: "Marketing",
    marketingDesc: "Perm\u00E8t\u00E8t des publicites personalis\u00E9yes.",
  },
  mobileCta: {
    submitInquiry: "F\u00E9 one dimande",
    craftBusiness: "Entreprise d' m\u00E9st\u00EE",
  },
  floatingPhone: {
    question: "Av\u00E9z des cw\u00E9stions? Ap\u00E9l\u00E9z nos:",
    ariaLabel: "Mon\u00EE l' num\u00E9ro d' t\u00E9l\u00E9fone",
  },
  home: {
    seoTitle: "Trouv\u00E9 on m\u00E9st\u00EE & r\u00E9cepe des dimandes di prodj\u00E9ts",
    seoDesc: "CRAFTFINDUS: Trouv\u00E9z l' bon m\u00E9st\u00EE po r\u00E9n ou r\u00E9cepez des dimandes di prodj\u00E9ts qualifiy\u00E9s.",
    heroLabel: "Li plate-forme di m\u00E9st\u00EE po vosse prodjt",
    heroTitle1: "Trouv\u00E9 l' bon",
    heroTitle2: "m\u00E9st\u00EE.",
    heroTitle3: "Sins lon cweri.",
    heroDesc: "D\u00E9crivez vosse prodjt. Nos trovons 3 \u00E0 5 entreprises po vos. Po r\u00E9n, \u00E9n m\u00E9s di 24 eures.",
    heroCta: "Trouv\u00E9 on m\u00E9st\u00EE po r\u00E9n",
    heroCtaCraft: "Dji so one entreprise d' m\u00E9st\u00EE",
    badge100Free: "100% po r\u00E9n",
    badgeResponse: "R\u00E9ponse \u00E9n <24h",
    badgeVerified: "Entreprises v\u00E9rifiy\u00E9yes",
    tradesLabel: "Vosse prodjt, nosse r\u00E9s\u00E9a",
    tradesTitle: "Trouv\u00E9z l' bon m\u00E9st\u00EE po chake m\u00E9st\u00EE",
    tradesDesc: "Cwat\u00EB k' c\u00E8 soy\u00EB \u2013 r\u00E9paracion, nouve b\u00E2timint ou r\u00E9novacion \u2013 {{brand}} trove l' bon\u00EB entreprise pr\u00E8s d' vos.",
    tradesCta: "Trouv\u00E9 on m\u00E9st\u00EE ast\u00E8re",
    electrician: "\u00C9lectricyin",
    electricianDesc: "Instalacion \u00E9l\u00E9ctrike, lumi\u00E8re, smart home \u2013 trouv\u00E9z on \u00E9lectricyin pr\u00E8s d' vos.",
    plumbing: "Plomb\u00EE & Tchof\u00E5dje",
    plumbingDesc: "R\u00E9novacion d' salle di bain, tchan\u00E2dje di tchof\u00E5dje \u2013 des instalateurs profesion\u00E8ls.",
    roofing: "Couvreus & Tcherpintis",
    roofingDesc: "R\u00E9novacion d' toit, luk\u00E8rnes \u2013 des couvreus exp\u00E9rim\u00E8nt\u00E9s.",
    painting: "Pinteurs & Careleuz",
    paintingDesc: "Pinture di fa\u00E7ade, tapiss\u00EE, sols \u2013 des m\u00E9st\u00EEs cr\u00E9atifs.",
    solar: "Fotovolta\u00EFke & Climat",
    solarDesc: "Pan\u00E9s sol\u00E8res, pompes \u00E0 tchaleur, clima \u2013 des solucions \u00E9n\u00E8rdjike durabe.",
    construction: "Costrucion & Am\u00E9na\u00E2dje",
    constructionDesc: "Placo, car\u00E9l\u00E5dje, r\u00E9novacion compl\u00E8te \u2013 tot d'one sole main.",
    howLabel: "3 simpes \u00E9tapes",
    howTitle: "Com\u00E8nt trouv\u00E9 l' bon m\u00E9st\u00EE",
    howDesc: "Pon d' lon cweri. Pon d' ap\u00E9ls sins fin. Nos v' guid\u00E8s.",
    step1Title: "D\u00E9crivez vosse prodjt",
    step1Desc: "R\u00E9pondez \u00E0 cwikes cw\u00E9stions \u2013 p.ex. 'R\u00E9nov\u00E9 l' salle di bain' ou 'Met\u00EB des pan\u00E9s sol\u00E8res'.",
    step2Title: "Les m\u00E9st\u00EEs sont s\u00E9l\u00E9cion\u00E9s",
    step2Desc: "{{brand}} trove otomatikm\u00E8nt djusk'\u00E0 5 entreprises ki cor\u00E9spondnut \u00E0 vosse prodjt.",
    step3Title: "On v' contacte",
    step3Desc: "Les entreprises s\u00E9l\u00E9cion\u00E9yes v' contact\u00E8t d\u00EEr\u00E8ktem\u00E8nt. Vos d\u00E9cidez ki c\u00E8 l' miy\u00E8.",
    benefitsLabel: "Avantadjes",
    benefitsTitle: "One plate-forme, deus gangnants",
    forClients: "Po les cli\u00E8nts",
    clientsTitle: "Trouv\u00E9 on m\u00E9st\u00EE: facile & po r\u00E9n",
    clientFree: "Compl\u00E8tem\u00E8nt po r\u00E9n",
    clientFreeDesc: "Pon d' fra, pon d' comission. Vos payez rin k' vosse m\u00E9st\u00EE.",
    clientNoJargon: "Pon d' jargon n\u00E9c\u00E9ssaire",
    clientNoJargonDesc: "D\u00E9crivez vosse prodjt avou vos propres mots. Nos trovons les bons m\u00E9st\u00EEs.",
    clientFast: "Des r\u00E9ponses rap\u00EEdes",
    clientFastDesc: "\u00C9n m\u00E9s di 24 eures, 3 \u00E0 5 entreprises v' contact\u00E8t.",
    clientQuality: "Qualit\u00E9 v\u00E9rifiy\u00E9ye",
    clientQualityDesc: "Totes les entreprises sont v\u00E9rifiy\u00E9yes. Les ma\u00EEstres sont m\u00E8tus \u00E9n \u00E9vid\u00E8nce.",
    clientCta: "F\u00E9 one dimande po r\u00E9n",
    forProviders: "Po les entreprises d' m\u00E9st\u00EE",
    providersTitle: "Des dimandes qualifiy\u00E9yes, sins efwart",
    providerMatched: "Des prodj\u00E9ts ki cor\u00E9spondnut",
    providerMatchedDesc: "Rin k' les dimandes ki cor\u00E9spondnut \u00E0 vosse m\u00E9st\u00EE, vosse r\u00E9gion et vosse capacit\u00E9.",
    providerCompetitors: "Max. 3 \u00E0 5 concur\u00E8nts",
    providerCompetitorsDesc: "Pon d' plate-forme di masse. Des tchances djustes.",
    providerTransparent: "Des cosses transparentes",
    providerTransparentDesc: "On pris fixe par dimande. Pon d' fra mensu\u00E8ls, pon d' comissions.",
    providerRate: "H\u00E5t t\u00E5s d' acceptacion",
    providerRateDesc: "Pace ki l' matching fonccionne: h\u00E5te qualit\u00E9, p\u00E9 d' piede.",
    providerCta: "S' \u00E9nscr\u00EEre come entreprise",
    principlesTitle: "Pocw\u00E9 {{brand}}?",
    principle1Num: "01",
    principle1Title: "Pon d' cweri, pon d' compar\u00E9",
    principle1Desc: "Nos n' mostr\u00E8s n\u00E9n des listes sins fin. Nosse algoritme s\u00E9l\u00E9cionne les bon\u00EBs entreprises po vos.",
    principle2Num: "02",
    principle2Title: "Qualit\u00E9 divant quantit\u00E9",
    principle2Desc: "Maximum 3 \u00E0 5 entreprises par prodjt. Vos av\u00E9z one vr\u00E5ye at\u00E8ncion.",
    principle3Num: "03",
    principle3Title: "Transparent & djuste",
    principle3Desc: "Chak\u00EEn s\u00E8t pocw\u00E9 on match a st\u00E9 f\u00E9t. Des condicions djustes po les deus costez.",
    statsTitle: "{{brand}} \u00E9n chifes",
    stat1Value: "3-5",
    stat1Label: "Entreprises par prodjt",
    stat2Value: "12+",
    stat2Label: "M\u00E9st\u00EEs disponibes",
    stat3Value: "<24h",
    stat3Label: "Timps d' r\u00E9ponse",
    stat4Value: "\u20AC0",
    stat4Label: "Cosses po les cli\u00E8nts",
    faqLabel: "FAQ",
    faqTitle: "Cw\u00E9stions fr\u00E9kw\u00E8ntes",
    faqDesc: "Des r\u00E9ponses po les cli\u00E8nts et les entreprises d' m\u00E9st\u00EE.",
    faqForClients: "Po les cli\u00E8nts",
    faqForProviders: "Po les entreprises",
    faqC1Q: "Dji n' sais nén cwél mestî qu' i m' fåt. Est-ce qui CRAFTFINDUS est po mi?",
    faqC1A: "Oyi, absolumint! CRAFTFINDUS est fêt po çoula. Dècrivez vosse prodjèt – nos trovans l' bon mestî et les mèyeûs entreprises po vos. Tot-à-fêt gratis.",
    faqC2Q: "Combin est-ce qui ça cosse di trover on-artisan?",
    faqC2A: "Po vos come cliènt, CRAFTFINDUS est tot-à-fêt gratis. Vos stitchîz vosse dimande, vos r'cevez 3 à 5 entreprises et vos dècidez vos-minme.",
    faqC3Q: "A qwand åreut-dji des rèponses?",
    faqC3A: "Djenerålmint, les entreprises vos contactèt d'vins les 24 eûres. Po les cas urgints, sovint co pus vite.",
    faqC4Q: "Cwéls prodjèts polèt-dji dimander?",
    faqC4A: "Totes sôres di prodjèts: èlèctricitè, plombereye, tchôfadje, toiture, amènadjmint, paneas solaires et co bråmint pus.",
    faqP1Q: "Ki-ce qui CRAFTFINDUS m' apcwète come entreprise?",
    faqP1A: "Vos r'cevez des dimandes pré-qualifiyèyes qui convnèt a vosse mestî et vosse rèdjion. Maximum 3 à 5 entreprises par dimande.",
    faqP2Q: "Comint est-ce qui l' matching fonctioneye?",
    faqP2A: "Nosse algoritme analyse tchaeke dimande et l' compare avou vosse profil: mestî, spècialisåcion, rèdjion, disponibilitè et grandeur do prodjèt.",
    faqP3Q: "Combin cosse CRAFTFINDUS po les entreprises?",
    faqP3A: "Vos payîz seûlmint on prix fixe et transparint par dimande acceptèye. Nol frès minsûls, nole comissions.",
    faqP4Q: "Ki-ce qui fêt l' difèrince avou les ôtes portails?",
    faqP4A: "Nol enchères, nol dumping di prix. A CRAFTFINDUS, les entreprises sont sèlèctionèyes, nin recherchèyes. Li limite di 3 à 5 entreprises garanti des chances djustes.",
    ctaLabel: "Cominci ast\u00E8re",
    ctaTitle: "K\u00EC c\u00E8 ki v' conv\u00E9nt?",
    ctaClientTitle: "Dji cwere on m\u00E9st\u00EE",
    ctaClientDesc: "D\u00E9crivez vosse prodjt. Nos trovons les bon\u00EBs entreprises po vos, po r\u00E9n.",
    ctaClientBtn: "F\u00E9 one dimande po r\u00E9n",
    ctaProviderTitle: "Dji so one entreprise d' m\u00E9st\u00EE",
    ctaProviderDesc: "R\u00E9cepez des dimandes ki cor\u00E9spondnut \u00E0 vosse profil. Sins \u00E8nch\u00E8re.",
    ctaProviderBtn: "S' \u00E9nscr\u00EEre ast\u00E8re",
  },
  auth: {
    seoTitle: "Si conect\u00E9 \u2013 Port\u00E5l d' m\u00E9st\u00EE",
    seoDesc: "Conect\u00E9z v' \u00E0 CRAFTFINDUS \u2013 l' port\u00E5l po les entreprises d' m\u00E9st\u00EE qualifiy\u00E9yes.",
    backToHome: "Riv\u00E9ni al p\u00E5dje principale",
    loginPrompt: "Conect\u00E9z v' \u00E0 vosse compte",
    emailLabel: "Emaye",
    emailPlaceholder: "vosse@emaye.be",
    passwordLabel: "Mot d' passe",
    passwordPlaceholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
    loginBtn: "Si conect\u00E9",
    invalidCredentials: "Datos nol valibes. Verifi\u00EEz v' infos.",
    alreadyRegistered: "Cisse adresse emaye est dd\u00E9dj\u00E0 \u00E9nregistr\u00E9ye.",
    registrationSuccess: "Enregistrem\u00E8nt r\u00E9uss\u00EE! Confirm\u00E9z vosse emaye.",
    loginSuccess: "Conect\u00E9 avou succ\u00E8s",
    invalidEmail: "M\u00E8tez one adresse emaye valibe",
    passwordMin: "Li mot d' passe dw\u00E8t av\u00E9 \u00E5 m\u00E9s 6 caract\u00E8res",
  },
  dashboard: {
    title: "Dimandes di prodj\u00E9ts",
    subtitle: "Des dimandes qualifiy\u00E9yes po vosse entreprise",
    tabNew: "Nov\u00E9s",
    tabInReview: "\u00C9n r\u00E9vizion",
    tabCompleted: "Finis",
    tabPayment: "Paym\u00E8nt & Facturacion",
    tabProfile: "Profil",
    noNew: "Pon d' nov\u00E9les dimandes",
    noInReview: "Pon d' dimandes \u00E9n cwas",
    noCompleted: "Pon d' dimandes finiy\u00E9yes",
    selectForDetails: "S\u00E9l\u00E9cion\u00E9z one dimande\npo les d\u00E9t\u00E5s",
    weeklyLimitReached: "Limite d' l' siman\u00EB atin\u00EEte",
    paymentMissing: "M\u00E9tode di paym\u00E8nt manke",
    paymentMissingDesc: "Les dimandes ser\u00E8t activ\u00E9yes apr\u00E8s l' configuracion do paym\u00E8nt.",
    setupPayment: "Configur\u00E9 ast\u00E8re \u2192",
    paymentRequired: "Configur\u00E9z d'abw\u00E8d one m\u00E9tode di paym\u00E8nt",
    subscriptionBlocked: "Abonm\u00E8nt blok\u00E9 \u2013 compl\u00E9t\u00E9z l' paym\u00E8nt",
    quotaExhausted: "Quota atin\u00EE \u2013 atch\u00E8t\u00E9z on add-on ou upgrade",
    acceptError: "Aroke \u00E0 l' acceptacion",
    accepted: "Dimande accept\u00E9ye",
    declined: "Dimande refuz\u00E9ye",
    declineError: "Aroke al r\u00E9fuzacion",
    questionSent: "Cw\u00E9stion \u00E9voy\u00E9ye",
    completed: "Dimande finiy\u00E9ye",
    completeError: "Aroke al finicion",
  },
  onboarding: {
    progressCompany: "Entreprise",
    progressTradesRegion: "M\u00E9st\u00EEs & R\u00E9gion",
    progressConfig: "Configuracion",
    companyTitle: "Vosse entreprise",
    companySubtitle: "Infos di b\u00E5ze po vosse profil",
    companyName: "No d' l' entreprise",
    companyNamePlaceholder: "Vosse entreprise d' m\u00E9st\u00EE",
    contactPerson: "Persone di contact",
    contactPersonPlaceholder: "Jean Dupont",
    masterCraftsman: "Ma\u00EEstre",
    masterCraftsmanDesc: "Vosse entreprise est on ma\u00EEstre \u00E9nregistr\u00E9",
    tradesTitle: "Vos m\u00E9st\u00EEs",
    tradesSubtitle: "K\u00EEs m\u00E9st\u00EEs cov\u00E8r\u00E9z v'?",
    regionTitle: "Vosse localisacion",
    regionSubtitle: "Wice est vosse entreprise?",
    regionLabel: "R\u00E9gion / Code post\u00E5l",
    regionPlaceholder: "p.ex. Li\u00E8dje, 4000",
    radiusTitle: "Ray\u00F4n d' sierv\u00EEce",
    radiusSubtitle: "Jusqu'\u00E0 wice al\u00E9z v' po les cli\u00E8nts?",
    limitTitle: "Limite di dimandes",
    limitSubtitle: "Comb\u00E8n d' dimandes voul\u00E9z v' par siman\u00EB?",
    limitFocused: "Focalis\u00E9",
    limitStandard: "Standard",
    limitIntensive: "Int\u00E8nsif",
    completeTitle: "Sov\u00E9 l' profil d' l' entreprise",
    summaryCompany: "Entreprise",
    summaryTrades: "M\u00E9st\u00EEs",
    summaryMaster: "Ma\u00EEstre",
    summaryRadius: "Ray\u00F4n",
    summaryLimit: "Limite",
    summaryPerWeek: "par siman\u00EB",
    saveProfile: "Sov\u00E9 l' profil",
    saving: "A sov\u00E9...",
    profileCreated: "Profil cre\u00E9",
    saveError: "Aroke al sovaedje",
    veryNear: "Tr\u00E8s pr\u00E8s",
    nearCity: "Pr\u00E8s d' l' vile",
    regional: "R\u00E9gion\u00E5l",
    wide: "L\u00E5dje zone",
    superRegional: "Super-r\u00E9gion\u00E5l",
  },
  inquiry: {
    seoTitle: "F\u00E9 one dimande \u2013 Trouv\u00E9 des entreprises qualifiy\u00E9yes",
    seoDesc: "Fé one dimande à CRAFTFINDUS: Décrivez vosse prodjt et nos trovons djusk'à 5 entreprises.",
    tradeElektriker: "Èlèctriciyin",
    tradeSanitaer: "Plombereye",
    tradeHeizung: "Tchôfadje",
    tradeDachdecker: "Covreû",
    tradeInnenausbau: "Amènadjmint intèrieûr",
    tradeSchreiner: "Minûzî",
    tradeBauunternehmen: "Entreprise di bâtimint",
    tradeFensterbauer: "Instalateûr di finiesses",
    tradeGartenbau: "Djårdenadje",
    tradePhotovoltaik: "Photovoltaïque",
    tradeKlimaanlagen: "Climatisåcion",
    tradeMalerbetrieb: "Peinteur",
    progressDetails: "Détås do prodjt",
    progressDescription: "Descrip\u00E7ion",
    progressContact: "Contact",
    questionOf: "Cw\u00E9stion {{current}} di {{total}}",
    tradeTitle: "K\u00EE m\u00E9st\u00EE av\u00E9z v' buz\u00E8gn?",
    tradeSubtitle: "S\u00E9l\u00E9cion\u00E9z l' m\u00E9st\u00EE",
    tradesLoading: "Les m\u00E9st\u00EEs tcherdy\u00E8t...",
    projectTypeTitle: "Sore di prodjt",
    projectTypeSubtitle: "K\u00EC c\u00E8 k' i faut f\u00E9?",
    repair: "R\u00E9paracion",
    repairDesc: "R\u00E9par\u00E9 des dom\u00E5djes exist\u00E8nts",
    newBuild: "Nouve b\u00E2timint",
    newBuildDesc: "Nov\u00E9 b\u00E2timint ou alondjim\u00E8nt",
    renovation: "R\u00E9novacion",
    renovationDesc: "R\u00E9nov\u00E9 l' exist\u00E8nt",
    installation: "Instalacion",
    installationDesc: "Met\u00EB on nov\u00E9 sist\u00E8me",
    objectTypeTitle: "Sore d' ob\u00E8t",
    objectTypeSubtitle: "K\u00EE sore di b\u00E2timint?",
    efh: "Maz\u00F4ne individuele",
    mfh: "Im\u00E8ube \u00E0 plusyeurs m\u00E9n\u00E5djes",
    commercial: "Comerce / Bureau",
    industrial: "Industri\u00E8l",
    publicBuilding: "B\u00E2timint public",
    urgencyTitle: "Com\u00E8nt c\u00E8 c' urgint?",
    urgencySubtitle: "Timps po cominci",
    immediate: "Tol s\u00E9te",
    immediateDesc: "L' pus vite possibe",
    oneWeek: "1 siman\u00EB",
    oneWeekDesc: "Dins les 7 dj\u00F4s ki v\u00E9n\u00E8t",
    oneMonth: "1 m\u00E5s",
    oneMonthDesc: "Dins les 30 dj\u00F4s ki v\u00E9n\u00E8t",
    flexible: "Flexibe",
    flexibleDesc: "Pon d' timps fix\u00E9",
    budgetTitle: "Budj\u00E8t \u00E9stim\u00E9",
    budgetSubtitle: "\u00C5de al matchaedje",
    under2k: "D'z\u00F4s \u20AC2.000",
    budget2k10k: "\u20AC2.000 \u00E0 \u20AC10.000",
    budget10k50k: "\u20AC10.000 \u00E0 \u20AC50.000",
    over50k: "P\u00FBs di \u20AC50.000",
    budgetUnclear: "Nin\u00EB co cl\u00E8r",
    descriptionTitle: "D\u00E9crivez vosse prodjt",
    descriptionSubtitle: "Max. 5.000 caract\u00E8res",
    descriptionPlaceholder: "K\u00EC c\u00E8 k' i faut f\u00E9? Des particularit\u00E9s?",
    desiredStart: "Date di d\u00E9but souh\u00E8t\u00E9ye (opcion\u00E8l)",
    locationTitle: "Wice est l' prodjt?",
    locationSubtitle: "Code post\u00E5l ou vile",
    contactTitle: "Vos coordon\u00E9yes",
    contactSubtitle: "Po \u00E8sse contact\u00E9 par les entreprises",
    contactNameLabel: "No *",
    contactNamePlaceholder: "Vosse no",
    contactEmailLabel: "Emaye *",
    contactPhoneLabel: "T\u00E9l\u00E9fone *",
    contactPhonePlaceholder: "+32 ...",
    toSummary: "\u00C0 l' ris\u00FBm\u00E9",
    commitTitle: "Transf\u00E8rt \u00E0 djusk'\u00E0 5 entreprises qualifiy\u00E9yes",
    commitDesc: "Vosse dimande s\u00E8r\u00E5 \u00E9voy\u00E9ye d\u00EEr\u00E8ktem\u00E8nt \u00E0 des entreprises di vosse r\u00E9gion.",
    summaryTrade: "M\u00E9st\u00EE",
    summaryProjectType: "Sore di prodjt",
    summaryUrgency: "Urdj\u00E8nce",
    summaryLocation: "Localisacion",
    summaryBudget: "Budj\u00E8t",
    submitInquiry: "\u00C9voy\u00EE l' dimande",
    submitting: "A \u00E9voy\u00EE...",
    submitSuccess: "Dimande \u00E9voy\u00E9ye avou succ\u00E8s",
    submitError: "Aroke \u00E0 l' \u00E9voyaedje",
  },
  thankyou: {
    inquiryTitle: "Vosse dimande a st\u00E9 r\u00E9cepuwe",
    inquiryDesc: "Nos match\u00E8s vosse prodjt avou nosse r\u00E9s\u00E9a d' entreprises qualifiy\u00E9yes.",
    nextStepsTitle: "K\u00EC c\u00E8 ki s' passe apr\u00E8s",
    inquiryStep1: "Nos v\u00E9rifiy\u00E8s vosse dimande et trovons djusk'\u00E0 5 entreprises.",
    inquiryStep2: "Vos r\u00E9cepez des sug\u00E8stions par emaye \u2013 djener\u00E5lm\u00E8nt dins les 24 eures.",
    inquiryStep3: "Vos d\u00E9cidez lib\u00E8rm\u00E8nt avou kile entreprise caz\u00E9.",
    urgentContact: "Po des cw\u00E9stions urdj\u00E8ntes, ap\u00E9l\u00E9z nos \u00E0",
    registrationTitle: "Enregistrem\u00E8nt r\u00E9cep\u00FB!",
    registrationDesc: "M\u00E8rci po vosse int\u00E9r\u00E8sse po CRAFTFINDUS.",
    registrationStep1: "Nosse \u00E9kipe v\u00E9rifiye vos infos.",
    registrationStep2: "Apr\u00E8s v\u00E9rificacion, vos r\u00E9cepez vos accesses par emaye.",
    registrationStep3: "Vos p\u00F4rez v' conect\u00E9 et r\u00E9cepe des dimandes tol s\u00E9te.",
    reviewTime: "Li v\u00E9rificacion prind djener\u00E5lm\u00E8nt 1\u20132 dj\u00F4s ovr\u00E5bes.",
    contactTitle: "M\u00E8rci po vosse m\u00E8ssadje",
    contactDesc: "Nos avons r\u00E9cep\u00FB vosse dimande et nos v' r\u00E9pondrons l' pus vite possibe.",
    contactResponse: "Nos r\u00E9pondons djener\u00E5lm\u00E8nt dins les 24 eures les dj\u00F4s ovr\u00E5bes.",
    sendAnother: "\u00C9voy\u00EE on ote m\u00E8ssadje",
  },
  contact: {
    seoTitle: "Contact \u2013 Conect\u00E9z v' avou CRAFTFINDUS",
    seoDesc: "Contact\u00E9z CRAFTFINDUS: Des cw\u00E9stions su les dimandes, l' enregistrem\u00E8nt ou l' partn\u00E8riat?",
    title: "Contact",
    desc: "Av\u00E9z des cw\u00E9stions su {{brand}} ou voul\u00E9z v' nos conect\u00E9? Nos ratindons vosse m\u00E8ssadje.",
    phoneLabel: "T\u00E9l\u00E9fone",
    emailLabel: "Emaye",
    nameLabel: "No *",
    namePlaceholder: "Vosse no",
    emailFieldLabel: "Emaye *",
    emailPlaceholder: "vosse@emaye.be",
    subjectLabel: "Sudj\u00E8t *",
    subjectPlaceholder: "Di cwet c\u00E8 k' i s' adj\u00EE?",
    messageLabel: "M\u00E8ssadje *",
    messagePlaceholder: "Vosse m\u00E8ssadje...",
    sendBtn: "\u00C9voy\u00EE l' m\u00E8ssadje",
    sending: "A \u00E9voy\u00EE...",
    sent: "M\u00E8ssadje \u00E9voy\u00E9!",
    sendFailed: "\u00C9voyaedje rat\u00E9. Ess\u00E8y\u00E9z pus t\u00E5d.",
    nameRequired: "M\u00E8tez vosse no",
    emailRequired: "M\u00E8tez one adresse emaye valibe",
    subjectRequired: "M\u00E8tez on sudj\u00E8t",
    messageMin: "Li m\u00E8ssadje dw\u00E8t av\u00E9 \u00E5 m\u00E9s 10 caract\u00E8res",
  },
  about: {
    seoTitle: "A propo d' CRAFTFINDUS \u2013 Matchaedje djuste & int\u00E8lidj\u00E8nt",
    seoDesc: "CRAFTFINDUS conecre les cli\u00E8nts avou des entreprises d' m\u00E9st\u00EE qualifiy\u00E9yes.",
    heroLabel: "A propo d' {{brand}}",
    heroTitle1: "Les djins d\u00E8ri",
    heroTitle2: "CRAFTFINDUS.",
    heroDesc: "{{brand}} a n\u00E8h\u00EE d'one simpe ob\u00E8rvacion: Les cli\u00E8nts trov\u00E8t m\u00E5 l' bon m\u00E9st\u00EE.",
    teamLabel: "Nosse \u00E9kipe",
    teamTitle: "Les djins d\u00E8ri",
    founderRole: "Fondateur",
    founderBio1: "Come \u00E8ntrep\u00E8neur di Solingen, dji con\u00E8h les deus costez.",
    founderBio2: "{{brand}} c\u00E8 m' r\u00E9ponse \u00E0 ci prob\u00E8me.",
    chrisRole: "Part\u00E8n\u00E8re",
    chrisBio: "Chris ap\u00E8te do strat\u00E9djike et d' l' exp\u00E9ri\u00E8nce d' \u00E8ntreprise.",
    veronikaRole: "Assist\u00E8nte & Backoffice",
    veronikaBio: "Veronika t\u00E8nt tos les fils \u00E8nsonle d\u00E8ri l' ridea.",
    dukeRole: "Tch\u00E9n d' bureau & Feel-Good-Manager",
    dukeBio: "Pon d' r\u00E9union sins Duke. Nosse Bull Terrier am\u00E8ne del bon\u00EB humeur.",
    valuesLabel: "Nos val\u00E8urs",
    valuesTitle: "Cwet c\u00E8 k' nos d\u00E9findons",
    value1Title: "Qualit\u00E9 divant quantit\u00E9",
    value1Desc: "Nos croyons \u00E0 m\u00E9s di conecsioms, m\u00E8 des miy\u00E8s. Chake dimande est limit\u00E9ye \u00E0 3 \u00E0 5 entreprises.",
    value2Title: "Djust\u00E8sse po les deus costez",
    value2Desc: "Po r\u00E9n po les cli\u00E8nts, des pris fixes transparents po les entreprises.",
    value3Title: "Simplictt\u00E9",
    value3Desc: "Li m\u00E9st\u00EE est assez complexe. Nos f\u00E9s l' tch\u00E8min l' pus facile possibe.",
    missionLabel: "Nosse mission",
    missionTitle: "Matchaedje di m\u00E9st\u00EE, come i faut",
    missionP1: "Li march\u00E9 do m\u00E9st\u00EE est fragm\u00E8nt\u00E9.",
    missionP2: "{{brand}} l' f\u00E9t dif\u00E9r\u00E8mm\u00E8nt: nos s\u00E9l\u00E9cion\u00E8s 3 \u00E0 5 entreprises par dimande.",
    missionP3: "Nosse but: \u00E8sse li prumi\u00E8 r\u00E9f\u00E9r\u00E8nce dins l' r\u00E9gion DACH.",
    ctaTitle: "Pr\u00E8ts \u00E0 nos con\u00E8he?",
    ctaDesc: "K\u00EC vos cwer\u00E9z on m\u00E9st\u00EE ou ki vos vol\u00E9z r\u00E9cepe des dimandes: nos v' ratindons.",
    ctaInquiry: "F\u00E9 one dimande",
    ctaContact: "Nos conect\u00E9",
  },
  pricing: {
    seoTitle: "Pris \u2013 Abonm\u00E8nts po les entreprises d' m\u00E9st\u00EE",
    seoDesc: "Des pl\u00E5ns mensu\u00E8ls transparents po des dimandes qualifiy\u00E9yes.",
    heroLabel: "Pris",
    heroTitle1: "Pus d' eur\u00E8s.",
    heroTitle2: "M\u00E9s d' tiyde.",
    heroDesc: "Tch\u00FBzih\u00E9z l' pl\u00E5n ki conv\u00E9nt \u00E0 vosse entreprise.",
    leadsIncluded: "leads accept\u00E9s compris",
    choosePlan: "Tch\u00FBzi on pl\u00E5n",
    mostPopular: "Pl\u00E5n l' pus populaire",
    addonsLabel: "Add-ons",
    addonsTitle: "Rézervé des leads adicionels",
    radiusLabel: "Elardjismints d' rayon",
    radiusTitle: "Elardjî vosse zone di siervice",
    radiusDesc: "Elardjîhéz vosse rayon et récepez des dimandes d'on pus grand territwêre.",
    trustNoContract: "Pon d' èngadjemènt",
    landingLabel: "Pris po les artisans",
    landingTitle: "Plåns d' abonmènt transparents",
    landingDesc: "Tchûzihéz l' plån ki convént – pon d' frès catchîs, pon d' èngadjemènt.",
    landingCta: "Vèy tos les plåns",
    trustInstant: "Pr\u00E8t tol s\u00E9te",
    trustVerified: "Rin k' des dimandes v\u00E9rifiy\u00E9yes",
    faqLabel: "Cw\u00E9stions fr\u00E9kw\u00E8ntes",
    faqTitle: "Cw\u00E9stions su les pris",
    ctaTitle: "Pr\u00E8ts po des nov\u00E9s eur\u00E8s?",
    ctaDesc: "Enregistr\u00E9z v' po r\u00E9n, tch\u00FBzih\u00E9z vosse pl\u00E5n et r\u00E9cepez des dimandes ki cor\u00E9spondnut.",
    ctaBtn: "S' \u00E9nscr\u00EEre ast\u00E8re",
    faq1q: "Payiy dji rin k' \u00E0 l' acceptacion?",
    faq1a: "N\u00E9n\u00EE \u2013 avou on abonm\u00E8nt vos pay\u00E9z on montant fixe par m\u00E5s.",
    faq2q: "K\u00EC c\u00E8 k' i s' passe cwand m' quota est ep\u00FBz\u00E9?",
    faq2a: "Vos poul\u00E9z atch\u00E8t\u00E9 on add-on po des leads adicionels.",
    faq3q: "Poli tchandj\u00EE d' pl\u00E5n?",
    faq3a: "Oy\u00EE, vos poul\u00E9z upgrade a n'impwate k\u00EE moum\u00E8nt.",
    faq4q: "I gn a on \u00E8ngadjem\u00E8nt?",
    faq4a: "N\u00E9n\u00EE. Vos poul\u00E9z r\u00E9zili\u00EE vosse abonm\u00E8nt a l' fin d' chake p\u00E9riode.",
    faq5q: "K\u00EC c\u00E8 ki sp\u00E9ci\u00E5l dins l' pl\u00E5n 'Premium'?",
    faq5a: "Les entreprises Premium r\u00E9cev\u00E8t on badje V\u00E9rifi\u00E9 et sont priorit\u00E8res.",
  },
  billing: {
    title: "Facturacion & Pl\u00E5n",
    subtitle: "Djer\u00E9z vosse pl\u00E5n, quotas et m\u00E9tode di paym\u00E8nt",
    tabPlan: "Pl\u00E5n & Facturacion",
    tabQuotas: "Quotas",
    tabPayment: "M\u00E9tode di paym\u00E8nt",
    statusActive: "Actif",
    statusTrial: "P\u00E9riode d' ess\u00E8y",
    statusPastDue: "Paym\u00E8nt \u00E9n r\u00E8t\u00E5d",
    statusBlocked: "Blok\u00E9",
    statusCanceled: "R\u00E9zili\u00E9",
    statusPending: "\u00C9n at\u00E8nte",
    pastDueBanner: "Paym\u00E8nt rat\u00E9. M\u00E8tez \u00E0 djo\u00FB vosse m\u00E9tode di paym\u00E8nt.",
    blockedBanner: "Abonm\u00E8nt blok\u00E9. Compl\u00E9t\u00E9z l' paym\u00E8nt po continu\u00EE.",
    updatePayment: "M\u00E8te \u00E0 djo\u00FB l' paym\u00E8nt",
    cancelledNotice: "Vosse abonm\u00E8nt finih l' {{date}}.",
    cancelSub: "R\u00E9zili\u00EE l' abonm\u00E8nt",
    cancelConfirm: "Vol\u00E9z v' vr\u00E5ym\u00E8nt r\u00E9zili\u00EE vosse abonm\u00E8nt?",
    cancelSuccess: "L' abonm\u00E8nt s\u00E8r\u00E5 r\u00E9zili\u00E9 \u00E0 l' fin d' l' p\u00E9riode",
    noPlan: "Pon d' pl\u00E5n actif",
    noPlanDesc: "Tch\u00FBzih\u00E9z on pl\u00E5n po r\u00E9cepe des dimandes qualifiy\u00E9yes.",
    changePlan: "Tchandj\u00EE d' pl\u00E5n",
    selectPlan: "Tch\u00FBzi on pl\u00E5n",
    currentPlan: "Actuel",
    activePlan: "Pl\u00E5n actif",
    leadsIncl: "Leads compris",
    addonsTitle: "Add-ons",
    buy: "Atch\u00E8t\u00E9",
    acceptedLeads: "Leads accept\u00E9s",
    deliveries: "Livr\u00E8sons",
    quotaReached: "Quota atin\u00EE \u2013 atch\u00E8t\u00E9z on add-on ou upgrade",
    billingPeriod: "P\u00E9riode di facturacion",
    periodResets: "Les quotas sont r\u00E9-init\u00EEalis\u00E9s otomatikm\u00E8nt.",
  },
  registration: {
    seoTitle: "\u00C9nregistr\u00E9 vosse entreprise \u2013 R\u00E9cepe des dimandes qualifiy\u00E9yes",
    seoDesc: "\u00C9nregistr\u00E9z vosse entreprise a CRAFTFINDUS: Pr\u00E8t \u00E9n 15 minutes.",
    title: "S' \u00E9nscr\u00EEre come entreprise d' m\u00E9st\u00EE",
    subtitle: "Rimplix\u00E9z l' formulaire. Apr\u00E8s v\u00E9rificacion, vos r\u00E9cepez vos accesses par emaye.",
    requiredFields: "Tchamps oblidj\u00E9s: No d' l' entreprise, persone di contact, emaye",
    fillRequired: "Rimplix\u00E9z l' no d' l' entreprise, l' persone di contact et l' emaye.",
    submitting: "A \u00E9voy\u00EE...",
    submitBtn: "\u00C9voy\u00EE l' enregistrem\u00E8nt",
    submitError: "Aroke \u00E0 l' \u00E9voyaedje",
  },
  handwerker: {
    seoTitle: "Gagni des cli\u00E8nts \u2013 Des dimandes sins prospection",
    seoDesc: "Gagn\u00E9z des cli\u00E8nts sins prospection: CRAFTFINDUS livre des dimandes qualifiy\u00E9yes.",
    heroLabel: "Po les entreprises d' m\u00E9st\u00EE",
    heroTitle1: "Des dimandes qualifiy\u00E9yes.",
    heroTitle2: "Pon d' guere di pris.",
    heroDesc: "{{brand}} v' livre des dimandes di cli\u00E8nts ki ont buz\u00E8gn d'on m\u00E9st\u00EE ast\u00E8re.",
    registerFree: "S' \u00E9nscr\u00EEre po r\u00E9n",
    badgeNoContract: "Pon d' \u00E8ngadjem\u00E8nt",
    badgeReady: "Pr\u00E8t \u00E9n 15 min",
    badgeVerified: "Rin k' des dimandes v\u00E9rifiy\u00E9yes",
    badgePayOnAccept: "Paym\u00E8nt rin \u00E0 l' acceptacion",
    benefitsLabel: "Vos avantadjes",
    benefitsTitle: "Pocw\u00E9 les entreprises tch\u00FBzih\u00E8t {{brand}}",
    benefit1Title: "Preciz\u00E8m\u00E8nt match\u00E9",
    benefit1Desc: "Nosse algoritme matche chake dimande avou vosse profil.",
    benefit2Title: "Max. 3 \u00E0 5 entreprises par prodjt",
    benefit2Desc: "Pon d' distribucion di masse. M\u00E9s d' concur\u00E8nce, pus d' r\u00E9ussite.",
    benefit3Title: "Pris fixes transparents",
    benefit3Desc: "Vos pay\u00E9z rin par dimande accept\u00E9ye \u2013 on pris fixe.",
    benefit4Title: "Dimandes v\u00E9rifiy\u00E9yes",
    benefit4Desc: "Chake dimande est v\u00E9rifiy\u00E9ye divant d' v' \u00E8sse \u00E9voy\u00E9ye.",
    benefit5Title: "Creuh\u00E5nce pr\u00E9visibe",
    benefit5Desc: "D\u00E9cid\u00E9z comb\u00E8n d' dimandes vos accept\u00E9z par m\u00E5s.",
    benefit6Title: "Acc\u00E8s rap\u00EEde",
    benefit6Desc: "Enregistr\u00E9z v', cre\u00E9z vosse profil, r\u00E9cepez des dimandes. Pr\u00E8t \u00E9n 15 minutes.",
    pricingLabel: "Ex\u00E8mples di pris",
    pricingTitle: "Pris fixes transparents par dimande",
    pricingDesc: "Vos pay\u00E9z rin po les dimandes ki vos accept\u00E9z.",
    smallProjects: "Ptits prodj\u00E9ts",
    smallExamples: "p.ex. prises \u00E9l\u00E9ctrikes, robinets, pinture di moura",
    mediumProjects: "Moy\u00E8ns & grands prodj\u00E9ts",
    mediumExamples: "p.ex. r\u00E9novacion d' salle di bain, pan\u00E9s sol\u00E8res, r\u00E9novacion compl\u00E8te",
    priceFrom: "dispoy \u20AC{{price}}",
    perAcceptedInquiry: "par dimande accept\u00E9ye",
    goodToKnow: "Bon \u00E0 sav\u00E9",
    goodToKnow1: "Pon d' fra mensu\u00E8ls. Paym\u00E8nt rin \u00E0 l' acceptacion",
    goodToKnow2: "Li grandeur do prodjt d\u00E9termine li pris",
    goodToKnow3: "R\u00E9clamacion po m\u00E5vaise qualificacion \u2013 remboursem\u00E8nt garanti",
    goodToKnow4: "Facturacion vi\u00E5 vosse m\u00E9tode di paym\u00E8nt",
    howLabel: "Com\u00E8nt \u00E7a fonccionne",
    howTitle: "3 \u00E9tapes po des nov\u00E9s prodj\u00E9ts",
    step1Title: "Cre\u00E9 vosse profil",
    step1Desc: "M\u00E9st\u00EE, r\u00E9gion, capacit\u00E9 et sp\u00E9cialisacion.",
    step2Title: "R\u00E9cepe des dimandes",
    step2Desc: "Les prodj\u00E9ts ki cor\u00E9spondnut v' sont livr\u00E9s otomatikm\u00E8nt.",
    step3Title: "Accept\u00E9 & conect\u00E9",
    step3Desc: "Vos d\u00E9cidez k\u00EEs prodj\u00E9ts accept\u00E9 et p\u00E5rl\u00E9z d\u00EEr\u00E8ktem\u00E8nt avou l' cli\u00E8nt.",
    startNow: "Cominci ast\u00E8re",
    faqLabel: "Cw\u00E9stions fr\u00E9kw\u00E8ntes",
    faqTitle: "Cw\u00E9stions des entreprises",
    ctaTitle: "Pr\u00E8ts po des dimandes qualifiy\u00E9yes?",
    ctaDesc: "Enregistr\u00E9z v' po r\u00E9n et r\u00E9cepez des prodj\u00E9ts ki cor\u00E9spondnut \u2013 sins \u00E8ngadjem\u00E8nt.",
    ctaBtn: "S' \u00E9nscr\u00EEre po r\u00E9n",
  },
  notFound: {
    title: "P\u00E5dje n\u00E8n trov\u00E9ye",
    description: "Li p\u00E5dje dimand\u00E9ye n' egziste n\u00E9n.",
  },
  limitReached: {
    title: "P\u00E5ze",
    subtitle: "Vosse limite d' l' siman\u00EB est atin\u00EEte.",
    nextReset: "Prochaine r\u00E9ouv\u00E8rture",
    description: "Li limite protédje li qualit\u00E9 d' l' plate-forme.",
    adjustLimit: "Adjuster l' limite",
  },
  completionDialog: {
    confirmTitle: "Fini l' dimande",
    confirmDesc: "Li dimande est finiyéye et l' contact avou l' cliènt est fini?",
    confirmYes: "Oyî, fini",
    confirmNo: "Nénî, rivéni",
    outcomeTitle: "Rézultåt",
    outcomeDesc: "On-z a sté on eurè?",
    won: "Oyî – Eurè gagnéye",
    lost: "Nénî – Eurè pièrdue",
    noFit: "Pon d' fit / Nèn shuvu",
  },
  aiSearch: {
    title: "Kécé ki c'est CRAFTFINDUS ?",
    definition: "CRAFTFINDUS est one platefôrme numérîke di qualité po l' mîse en relåcion avou des entreprîses artisanåles vérifiyéyes en Almagne, Otriche, Swisse, Pays-Bas, Bèljike, France èt Pologne. Lès doneur d'ôrdre discrivèt leû prodjèt – CRAFTFINDUS trove grâce à on matching intèlidjènt 3 à 5 artisans qualifiyés dins leû réjion. Li sèrvice est gratût èt sins engadjmènt po lès doneur d'ôrdre.",
    highlight1: "Entreprîses vérifiyéyes : immatriculåcion, assurance, solvabilité contrôlées",
    highlight2: "Max. 3–5 entreprîses par prodjèt : chances équitåbles",
    highlight3: "Prix transparants : prix d' contact fixès, nole frès catchîs",
    highlight4: "Procèssus d' réclamåcion équitåble : rimborsemint po contacts nén qualifiyés",
  },
  seoLanding: {
    verified: "Entreprises vérifiyéyes",
    free: "Po rén & sins engadjmènt",
    fast: "Réponse én 24h",
    ctaRequest: "Fé one dimande astère",
    freeForClients: "Po rén po les cliènes",
    whatIsCraftfindus: "Ki-ce ki c'è CRAFTFINDUS?",
    whatIsCraftfindusText: "CRAFTFINDUS est one plate-forme numèrike ki mèt les cliènes én contact avou des entreprises d' mèstî vérifiyéyes én Almagne, Otriche, Swisse, Bèljike, Pays-Bas, France et Pologne. Décrivez vosse prodjt – nos trovons 3 à 5 entreprises adèkwates près d' vos. Po rén et sins engadjmènt.",
    verifiedProviders: "{{trade}} vérifiyés à {{city}}",
    howItWorks: "Comènt fonctioneye CRAFTFINDUS",
    costs: "Cosses & pris {{trade}}",
    inCity: "à {{city}}",
    faq: "Cwéstions frékwèntes",
    ctaHeading: "{{trade}} à {{city}} cwèru?",
    ctaSubtext: "Fé vosse dimande po rén et récepez djusk'à 5 offes d' entreprises vérifiyéyes.",
    relatedCities: "{{trade}} dins d' ôtes viles",
    otherTrades: "Ôtes mèstîs à {{city}}",
    relatedArticles: "Gudes asociyés",
  },
  blog: {
    title: "Gude CRAFTFINDUS",
    description: "Des consèys, des cosses et des gudes po les prodjèts d' mèstî",
    noPosts: "Nol artike po l' moumint.",
    backToList: "Rivéni al gude",
  },
  warum: {
    seoTitle: "Pocwé CRAFTFINDUS – Li plate-forme di qualité po l' mèstî",
    seoDesc: "Dècovrez pocwé CRAFTFINDUS est difèrènt: contrôle di qualité des leads, pris transparints, entreprises vérifiyéyes et processus d' réclimåcion djuste.",
    heroLabel: "Pocwé CRAFTFINDUS",
    heroTitle1: "Li matchaedje d' mèstî,",
    heroTitle2: "come i dwèt ièsse.",
    heroDesc: "Li plupårt des plates-formes distribuèt des contacts. Nos connectons des prodjèts qualifiyés avou des entreprises vérifiyéyes – djustemint, transparintmint.",
    problemLabel: "Li problème do martchî",
    problemTitle: "Ki-ce ki va mål so les ôtes plates-formes",
    problem1Title: "Des dimandes nin qualifiyéyes",
    problem1Desc: "Des contacts sins budjèt, sins vrè prodjèt. Vos payîz po des leads ki n' divnèt måy des eures.",
    problem2Title: "Des cosses opakes",
    problem2Desc: "Des frès catchîs, des comissions so les eures, des modèles di pris flos.",
    problem3Title: "Distribucion di masse",
    problem3Desc: "Vosse dimande va à 10, 15 ou 20 entreprises èn minme timps. Li rézultåt: guère di pris, frustracion.",
    problem4Title: "Nol drwèt di réclamacion",
    problem4Desc: "Contact injoignabe? Målvès mèstî? Mål tchance. So li plupårt des plates-formes, i gn'a nole solucion djuste.",
    solutionLabel: "Nosse approche",
    solutionTitle: "Ki-ce ki CRAFTFINDUS fêt difèrintmint",
    solution1Title: "Score di qualité des leads",
    solution1Desc: "Tchaeke dimande est otomatikemint évaluéye. Seûles les dimandes avou on score > 60 sont facturéyes.",
    solution2Title: "Pris di contact transparints",
    solution2Desc: "Des pris fixes par contact – visibes à l'avance. Nole comissions, nols frès catchîs.",
    solution3Title: "Max. 3 à 5 entreprises par prodjèt",
    solution3Desc: "Tchaeke dimande va à on maximum di 5 entreprises vérifiyéyes. Mons d' concurrence, mèyeûs tås d' fèrmaedje.",
    solution4Title: "Processus d' réclamacion djuste",
    solution4Desc: "Contact injoignabe? Målvès mèstî? Vos r'cevez vosse pris di contact – d'vins les 72 eûres, garanti.",
    solution5Title: "Entreprises vérifiyéyes",
    solution5Desc: "Registråcion, assurance, solvabilité – nos entreprises passèt on processus di vérificåcion èn plusieûrs étapes.",
    solution6Title: "Mécanisme di djustèce",
    solution6Desc: "Détèkcion otomatike des abus, tablo d' bôrd di transparince et tås d' réclamacion maximum protèdjèt li qualité d' l' plate-forme.",
    ctaTitle: "Convaincu?",
    ctaClientBtn: "Cominci vosse prodjèt profesionèlmint",
    ctaProviderBtn: "Obt'ni pus d' prodjèts qualifiyés",
  },
  inquiryPsych: {
    qualityHint: "Pus vos infos sont précises, mèyeûs les entreprises ki vos r'cevrez.",
    timePromise: "Prind mons d' 2 minutes",
    matchingHint: "Nos vérifiins vosse dimande divant d' l' transmète ås entreprises.",
    descShort: "Décrivez vosse prodjèt on pô pus én détå s.v.p.",
    descGood: "Egzcelinte descrip\u00E7ion – çoula ôgminte vos tchances d' récépe des offes rapidemint.",
    photoHint: "Les fotos ådèt à one évaluåcion précise.",
  },
  quality: {
    seoTitle: "Promèsse di qualité – Comènt fonctioneye CRAFTFINDUS",
    seoDesc: "Décovrez comènt nos vérifiins les prodjèts, contrôlons les entreprises, facturons djustemint et trêtons les réclamacions.",
    heroLabel: "Nosse promèsse di qualité",
    heroTitle1: "Transparince.",
    heroTitle2: "Nin seûlmint one promèsse.",
    heroDesc: "Nos v' èsplikons egzactemint comènt nosse plate-forme fonctioneye – di l' vérificåcion des prodjèts à l' réclamacion.",
    sec1Title: "Comènt les prodjèts sont vérifiîs",
    sec1Desc: "Tchaeke dimande passe par nosse moteûr di qualité otomatike. Seûles les dimandes avou on score d'å mons 60 ponts sont transmises.",
    sec1Item1: "Numéro d' téléfone vérifiyé (+20 ponts)",
    sec1Item2: "Budjèt indikié (+25 ponts)",
    sec1Item3: "Descrip\u00E7ion do prodjèt vérifiéye (+10 ponts)",
    sec1Item4: "Coordonéyes complètes (+10 ponts)",
    sec2Title: "Comènt les entreprises sont vérifiéyes",
    sec2Desc: "Nos entreprises passèt on processus di vérificåcion èn plusieûrs étapes. Seûles les entreprises vérifiéyes r'cevèt des dimandes.",
    sec2Item1: "Registråcion al registre do comèrce vérifiéye (Nivea 1)",
    sec2Item2: "Assurance rèsponsabilité civile vérifiéye (Nivea 2)",
    sec2Item3: "Vérificåcion di solvabilité réussîye (Nivea 3)",
    sec2Item4: "Vérificåcion d'identité finiéye (Nivea 3)",
    sec3Title: "Comènt fonctioneye li facturacion",
    sec3Desc: "Des cosses transparintes et prévisibes. Nols frès catchîs, noles comissions.",
    sec3Item1: "Pris fixes par contact – visibes à l'avance",
    sec3Item2: "Modèles flexibes: Flex, Professional, Premium",
    sec3Item3: "Facturacion mensuwèle, résiliabe à tot moumint",
    sec4Title: "Comènt fonctionèt les réclamacions",
    sec4Desc: "Processus djuste po les plaintes lédjitimes. Remboursemènt d'vins les 72 eûres.",
    sec4Item1: "Réclamacion directemint dins l' tablo d' bôrd",
    sec4Item2: "Motifs: Injoignabe, målvès mèstî, nin on vrè prodjèt",
    sec4Item3: "Les réclamacions lédjitimes sont remboursyéyes tol séte",
    ctaTitle: "Co des cwéstions?",
    ctaDesc: "Contactez-nos ou comincîz – nos incarnons transparince et djustèce.",
    ctaClientBtn: "Cominci vosse prodjèt profesionèlmint",
    ctaProviderBtn: "Obt'ni pus d' prodjèts qualifiyés",
  },
};

export default wa;
